import React from "react";
import useRemittanceInvoice from "./useRemittanceInvoice";
import { useSelector } from "react-redux";
import Style from "./invoice.module.scss";
import Assets from "../../../../assets/Assets";
import InvoiceShimmer from "../../../Global/Shimmers/InvoiceShimmer";
const RemittanceInvoice = ({ remittanceId }) => {
  const {
    invoice,
    loading,
    invoiceRef,
  } = useRemittanceInvoice({ remittanceId });
  const globalState = useSelector((state) => state.global);

  return (
    <div className="pro-py-5 pro-pt-0">
      {loading ? (
        <InvoiceShimmer />
      ) : (
        <div className="pro-w-100">
          <div ref={invoiceRef} className="pro-mx-5 pro-pt-5">
            <div className="pro-w-100 pro-pb-5">
              <div className={`${Style.logoWrapper} pro-pb-3 pro-pt-2`}>
                <figure className="pro-mb-0">
                  <img
                    src={
                      globalState.currentTheme === "light" ||
                      globalState.currentTheme === null
                        ? Assets.HEADERLOGO
                        : Assets.HEADERLOGODARK
                    }
                    alt="logo"
                  />
                </figure>
              </div>
              <table className={Style.user_detail_table}>
                <tbody>
                  <tr>
                    <td>
                      <label
                        htmlFor=""
                        className={`pro-font-xs pro-mb-0 ${Style.label}`}
                      >
                        Application Name
                      </label>
                      <p className="pro-mb-0 pro-fw-bold">
                        {invoice?.application_name}
                      </p>
                    </td>
                    <td>
                      <label
                        htmlFor=""
                        className={`pro-font-xs pro-mb-0 ${Style.label}`}
                      >
                        Branch
                      </label>
                      <p className="pro-mb-0 pro-fw-bold">{invoice?.branch}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label
                        htmlFor=""
                        className={`pro-font-xs pro-mb-0 ${Style.label}`}
                      >
                        Remittance No
                      </label>
                      <p className="pro-mb-0 pro-fw-bold">
                        {invoice?.remittance_no}
                      </p>
                    </td>
                    <td>
                      <label
                        htmlFor=""
                        className={`pro-font-xs pro-mb-0 ${Style.label}`}
                      >
                        Purpose
                      </label>
                      <p className="pro-mb-0 pro-fw-bold">
                        {invoice?.purpose}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label
                        htmlFor=""
                        className={`pro-font-xs pro-mb-0 ${Style.label}`}
                      >
                        Date
                      </label>
                      <p className="pro-mb-0 pro-fw-bold">{invoice?.date}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <table className={Style.invoice_table}>
              <tbody>
                <tr>
                  <th>Currency</th>
                  <th>Rate</th>
                  <th>Quantity</th>
                  <th>Forex in INR</th>
                </tr>
                <tr>
                  <td>{invoice?.currency_code}</td>
                  <td>₹ {invoice?.currency_rate}</td>
                  <td>{invoice?.quantity}</td>
                  <td>₹ {invoice?.forex_in_inr}</td>
                </tr>
              </tbody>
            </table>

            <div className={`pro-d-flex pro-justify-end  pro-gap-3 pro-pt-2`}>
              <p className="pro-mb-0 pro-font-xs pro-flex-shrink-0">GST</p>
              {
                <div className="pro-text-end">
                  <p className="pro-mb-0" style={{ minWidth: 140 }}>
                    ₹ {invoice?.gst}
                  </p>
                </div>
              }
            </div>

            <div className={`pro-d-flex pro-justify-end  pro-gap-3 pro-pt-1`}>
              <p className="pro-mb-0 pro-font-xs pro-flex-shrink-0">TCS</p>
              {
                <div className="pro-text-end">
                  <p className="pro-mb-0" style={{ minWidth: 140 }}>
                    ₹ {invoice?.tcs}
                  </p>
                </div>
              }
            </div>

            <div className={`pro-d-flex pro-justify-end  pro-gap-3 pro-pt-1`}>
              <p className="pro-mb-0 pro-font-xs pro-flex-shrink-0">
                TT Charge
              </p>
              {
                <div className="pro-text-end">
                  <p className="pro-mb-0" style={{ minWidth: 140 }}>
                    ₹ {invoice?.tt_charge}
                  </p>
                </div>
              }
            </div>

            <div className={`pro-d-flex pro-justify-end  pro-gap-3 pro-pt-1`}>
              <p className="pro-mb-0 pro-font-xs pro-flex-shrink-0">
                Service Charge
              </p>
              {
                <div className="pro-text-end">
                  <p className="pro-mb-0" style={{ minWidth: 140 }}>
                    ₹ {invoice?.service_charge}
                  </p>
                </div>
              }
            </div>

            <div className={`pro-d-flex pro-justify-end  pro-gap-3 pro-pt-1`}>
              <p className="pro-mb-0 pro-font-xs pro-flex-shrink-0">
                Round Off
              </p>
              {
                <div className="pro-text-end">
                  <p className="pro-mb-0" style={{ minWidth: 140 }}>
                    ₹ {invoice?.round_off}
                  </p>
                </div>
              }
            </div>
            <div className={`${Style.table_btm_content} pro-pb-1`}>
              <div className={`pro-d-flex pro-justify-end  pro-gap-3 pro-pt-3`}>
                <h6 className="pro-mb-0 pro-font-sm pro-flex-shrink-0">
                  Total Amount
                </h6>

                <h6
                  className="pro-mb-1"
                  style={{ minWidth: 140, textAlign: "end" }}
                >
                  ₹ {invoice?.total_amount}
                </h6>
              </div>
              <p
                className={`pro-mb-0 pro-text-uppercase pro-text-end ${Style.total}`}
              >
                {invoice?.total_amount_inwords}
              </p>
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default RemittanceInvoice;
